import api from './api';
import store from '@/store';

export default {
  getBrokersList() {
    let filters = {
      whereHas: [
        {
          relation: 'businessType',
          filters: { where: [['name', '=', 'broker']] }
        }
      ]
    };

    if (store.getters.UserHasRole('Broker')) {
      filters.whereIn = ['id', store.getters.UserBusinesses];
    }

    const search = store.getters.BrokerSearch;
    if (search !== '') {
      filters.where = [['name', 'LIKE', `%${search}%`]];
    }

    const params = {
      orderby: 'name,asc',
      filters
    };

    return new Promise((resolve, reject) => {
      api
        .get('business', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  getBroker(id) {
    const params = {
      includes: 'users'
    };

    return new Promise((resolve, reject) => {
      api
        .get(`business/${id}`, { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  register(broker) {
    const details = {
      business: {
        commercialName: broker.name,
        type: 'broker'
      },
      firstName: broker.user.firstName,
      lastName: broker.user.lastName,
      email: broker.user.email,
      phone: broker.user.phone,
      parent_id: broker.parent_id,
      sub_domain: broker.subdomain,
      logo: broker.logo,
      web_site_header: broker.web_site_header,
      web_strapline: broker.web_strapline,
      branded_site: broker.branded,
      enabled: broker.enabled
    };

    return new Promise((resolve, reject) => {
      api
        .post('register', { details })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  update(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`business/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
